<template>
  <div v-if="activated">
    <div class="global-navi-wallet">
      <div class="global-navi-wallet-list">
        <ul>
          <li class="global-navi-wallet-list-coin">
            <a :href="coinPointLink" v-analytics="{label:'side_menu_mypoint'}">
              <p class="global-navi-wallet-icon-coin">コイン</p>
              <span class="global-navi-coin"><coin-balance class="global-navi-wallet-coin" />C</span>
            </a>
          </li>
          <li class="global-navi-wallet-list-point">
            <a :href="coinPointLink" v-analytics="{label:'side_menu_mypoint'}">
              <p class="global-navi-wallet-icon-point">ポイント</p>
              <span class="global-navi-point"><point-balance class="global-navi-wallet-point" />P</span>
            </a>
          </li>
          <li class="global-navi-wallet-list-coupon">
            <a :href="couponLink" v-analytics="{label:'side_menu_coupon'}">
              <p class="global-navi-wallet-icon-coupon">クーポン</p>
              <coupon-balance class="global-navi-wallet-coupon" />枚
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import CoinBalance   from '@istyle-inc/wallet-component/components/coin-balance';
import CouponBalance from '@istyle-inc/wallet-component/components/coupon-balance';
import PointBalance  from '@istyle-inc/wallet-component/components/point-balance';
import SideMenuItem  from '../side-menu-item';
import Config        from '../../../../libs/config';

export default {
  name      : 'side-menu-item-wallet',
  components: {
    CoinBalance,
    CouponBalance,
    PointBalance,
  },
  mixins: [SideMenuItem],
  data  : function() {
    return {
      activated    : false,
      coinPointLink: Config.SERVICE_LINK.ATCOSME.POINT.USER.URL,
      couponLink   : Config.SERVICE_LINK.ATCOSME.POINT.COUPON.URL,
    };
  },
  watch: {
    active: function() {
      if (!this.active) {
        return;
      }
      this.activated = true;
    },
  },
};
</script>
